import React, { useState } from "react";
import { NavLink } from "react-router-dom";

export const NotFound = () => {
  return (
    <div>
      <section className="mb-0">
        <div class="error_404">
          {/* 404 <span> error!</span> */}
          <p>
          This documentary is not available in your region.
            {/* <br /> */}
          
          </p>
          <NavLink to="/">
            <button className="backbtn">BACK TO HOME</button>
          </NavLink>
        </div>
      </section>
    </div>
  );
};
